import { useMutation } from '@tanstack/react-query';
import type { UseMutateFunction } from '@tanstack/react-query';
import { API_INTERACT_URL, axiosInt, downloadFromUrl } from '../utils';
import { useMessage } from './useMessage';

export const GET_FILE_PRESIGNED_URL_KEY = 'getFilePresignedUrl';

interface IDownloadFileParams {
  fileId: string;
}

export const getFilePresignedUrlApi = async (
  fileId: string
): Promise<string> => {
  const response = await axiosInt.get(`${API_INTERACT_URL}/files/${fileId}`);
  if (typeof response.data === 'string') {
    return response.data;
  }

  if (response.data.url) {
    return response.data.url;
  }

  return response.data;
};

export const useInteractDownloadFile = () => {
  const message = useMessage();

  const {
    mutate,
    isPending: isDownloadingFile,
    error: errorDownloadingFile,
  } = useMutation<string, Error, IDownloadFileParams>({
    mutationKey: [GET_FILE_PRESIGNED_URL_KEY],
    mutationFn: ({ fileId }) => getFilePresignedUrlApi(fileId),
    onSuccess: url => {
      downloadFromUrl(url);
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.detail ||
        error?.response?.data?.title ||
        error?.message ||
        'Failed to download file';
      message.error(errorMessage);
    },
  });

  const downloadFile: UseMutateFunction<
    string,
    Error,
    IDownloadFileParams,
    unknown
  > = mutate;

  return {
    downloadFile,
    isDownloadingFile,
    errorDownloadingFile,
  };
};
